import React from 'react';
import Avatar from '@mui/material/Avatar';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { Users as UsersIcon } from '@phosphor-icons/react/dist/ssr/Users';
import { CheckSquareOffset } from '@phosphor-icons/react/dist/ssr/CheckSquareOffset';

export default function OpenTasks({ sx, value }) {

  return (
    <Card sx={sx}>
      <CardContent>
        <Stack spacing={2}>
          <Stack direction="row" sx={{ alignItems: 'flex-start', justifyContent: 'space-between' }} spacing={3}>
            <Stack spacing={1}>
              <Typography color="text.secondary" variant="overline">
                Open Tasks
              </Typography>
              <Typography variant="h4">{value}</Typography>
            </Stack>
            <Avatar sx={{ backgroundColor: '#3cb28b', height: '56px', width: '56px' }}>
              <CheckSquareOffset fontSize="32" />
            </Avatar>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
}
